import { combineReducers } from 'redux';
import { ActionType } from 'typesafe-actions';
import {
  COMPETITIONS_FAILURE,
  COMPETITIONS_REQUEST,
  COMPETITIONS_SUCCESS,
} from '../../constants/competitions';
import { Competition } from '../../types/Competitions';
import { competitionsActions } from './actions';

export type CompetitionsState = {
  requested: boolean;
  data: Competition | null;
  isLoading: boolean;
  error: string | null;
};
export type CompetitionsActions = ActionType<typeof competitionsActions>;

export const competitionsReducer = combineReducers<
  CompetitionsState,
  CompetitionsActions
>({
  requested: (state = false, action) => {
    switch (action.type) {
      case COMPETITIONS_REQUEST:
        return true;
      default:
        return state;
    }
  },
  data: (state = null, action) => {
    switch (action.type) {
      case COMPETITIONS_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  isLoading: (state = false, action) => {
    switch (action.type) {
      case COMPETITIONS_REQUEST:
        return true;
      default:
        return false;
    }
  },
  error: (state = null, action) => {
    switch (action.type) {
      case COMPETITIONS_FAILURE:
        return action.payload.message || action.payload.detail;
      default:
        return null;
    }
  },
});
